import React, { FunctionComponent, useState } from 'react'
import { Text } from '@wework/dieter-ui'
import Row from '../Common/Row'
import linkIcon from '../../assets/icons/linkIcon.png'
import IMTheme from '../../style/IMTheme'
import LinkedRoom from './LinkedRoom'

interface LinkedRoomsProps {
  rooms: Array<any>
  getFloorName: (string) => string
  handleInternalRoomClick: (string) => string
}
const LinkedRooms: FunctionComponent<LinkedRoomsProps> = ({
  rooms,
  getFloorName,
  handleInternalRoomClick,
}) => {
  const [collapsed, setCollapsed] = useState(true)

  if (rooms.length === 0) {
    return null
  }
  return (
    <div>
      <Row justify="space-between" style={{ marginBottom: 8 }}>
        <Row justify="flex-start">
          <div>
            <img src={linkIcon} style={{ width: 16, height: 16 }} />
          </div>
          <Text
            style={{
              fontWeight: IMTheme.fontWeights.bold,
              fontSize: IMTheme.fontSizes[2],
              marginLeft: IMTheme.spacing[4],
            }}
          >
            {`Linked to ${rooms.length} ${rooms.length > 1 ? 'rooms' : 'room'}`}
          </Text>
        </Row>
        <Text
          primary
          style={{ fontSize: IMTheme.fontSizes[2], cursor: 'pointer' }}
          onClick={() => setCollapsed(!collapsed)}
        >
          {collapsed ? 'Show' : 'Hide'}
        </Text>
      </Row>

      {!collapsed && (
        <Row justify="flex-start">
          <div
            style={{
              flexDirection: 'column',
              display: 'flex',
              marginLeft: IMTheme.spacing[6],
              width: '100%',
            }}
          >
            {rooms.map((room, index) => {
              return (
                <LinkedRoom
                  key={room.id}
                  roomNumber={room.name}
                  floor={getFloorName(room.floor_uuid)}
                  handleInternalRoomClick={() => handleInternalRoomClick(room)}
                />
              )
            })}
          </div>
        </Row>
      )}
    </div>
  )
}

export default LinkedRooms
